var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix"},[_c('a-upload',{attrs:{"file-list":_vm.fileList,"remove":_vm.handleRemove,"before-upload":_vm.beforeUpload}},[_c('a-button',[_c('a-icon',{attrs:{"type":"upload"}}),_vm._v(" Select File ")],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }